import replaceVariables, {
  type PhraseValues,
} from "@workspace/cms-phrases/src/phrase/replaceVariables";
import translations from "./translations";

type Translate = (key: string, values?: PhraseValues) => string;

// Locale, then English, then the key itself. The key fallback also lets a
// backend-provided text pass through `t()` untouched.
const createTranslate = (locale: string): Translate => {
  const dictionary = translations[locale] ?? translations.en;

  return (key, values) =>
    replaceVariables(dictionary[key] || translations.en[key] || key, values);
};

export type { Translate };
export default createTranslate;
